import ComingSoon from "@/components/common/ComingSoon";
import PageLayout from "@/components/layout/PageLayout";
import { createFileRoute } from "@tanstack/react-router";
import CopyTradingGuides from "./-components/CopyTradingGuides";
import CopyTradingStatsCard from "./-components/CopyTradingStatsCard";

export const Route = createFileRoute("/_main/copy-trading/")({
  head: () => ({
    meta: [{ title: "Reactor | Copy Trading" }],
  }),
  component: CopyTradingPage,
});

function CopyTradingPage() {
  return (
    <PageLayout>
      <ComingSoon>
        <div className="p-2 md:p-[70px]">
          <section className="z-20 flex max-w-[1488px] flex-col items-start justify-start gap-8 [&>*]:z-20">
            <div className="flex flex-col items-start gap-4">
              <h1 className="text-4xl font-medium">Copy Trading Classic</h1>
              <p className="text-base text-gray-p md:text-center">
                Unlock Top Traders, Achieve Champion Profits
              </p>
            </div>
            <div className="flex w-full flex-col gap-1.5">
              <CopyTradingStatsCard totalAssets={100000} pnl={10000} />
              <CopyTradingGuides />
            </div>
          </section>
        </div>
      </ComingSoon>
    </PageLayout>
  );
}
